import { useState } from "react";
import { useNavigate } from "react-router-dom";

function Login()
{
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const nav = useNavigate();

    function handleEmailChange(e)
    {
        setEmail(e.target.value);
    }

    function handlePasswordChange(e)
    {
        setPassword(e.target.value);
    }

    function handleClick()
    {
        let url = "https://acepicklapi.raganindustries.com/api_user_login.php";
        let headers = {
            'Accept' : 'application/json',
            'Content-type' : 'application/json'
        };
        let values = {
            user_authcode : 1,
            user_authparameter : email,
            user_password : password
        };
        fetch(url, {
            method : 'POST',
            headers : headers,
            body : JSON.stringify(values)
        }).then((response) => response.json()).then((data) => {
            if(data.status == "STATUS OK")
            {
                window.sessionStorage.setItem("user_id", data.user_id);
                window.sessionStorage.setItem("user_name", data.user_fname + " " + data.user_lname);
                window.sessionStorage.setItem("user_accesstoken", data.access_token);
                nav("/chat");
            }
        });
    }

    return(
        <div>
            <input type = "text" placeholder = "Enter email" value = { email } onChange = { handleEmailChange } />
            <br/>
            <input type = "password" placeholder = "Enter password" value = { password } onChange = { handlePasswordChange } />
            <br/>
            <input type = "submit" value = "LOGIN" onClick = { handleClick } />
        </div>
    );
}

export default Login;